module.exports = __webpack_public_path__ + "media/images/ui__arrowLeft--dark-b9986e07f17c789c89505482b0624107.png";